import { IS_DEPLOYED } from '../../constants'
import { User } from '../services/user'

const disallowedEduDomains = [
  'fcps.edu',
  'fcpsschools.net',
  'winclusion.org',
  'test.fcpstechlab.org',
  'grammarlian.com',
]

export const isEligibleForTracking = (user: User): boolean => {
  if (!IS_DEPLOYED) {
    return false
  }
  return !disallowedEduDomains.some((domain) => user?.email?.endsWith(`@${domain}`))
}
